import stRanking from './stRanking';
import strategy from './strategy';
import taStrategy from './taStrategy';
import canslim from './canslim';

export default {
  canslim,
  stRanking,
  strategy,
  taStrategy,
};
